import { types, actions } from './requests'
export const GETMOLDLIST_TYPES = {
    ...types('GETMOLDLIST'),
}
export const GETMOLDLIST_ACTIONS = {
    ...actions('GETMOLDLIST'),
}